import { FETCH_OFFER_DESTINATION_LIST } from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
  selectList: [],
};

const offerDestinationListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_OFFER_DESTINATION_LIST:
      return { list: action.payload, others: action.others };
    default:
      return state;
  }
};

export default offerDestinationListReducer;
